import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface FeatureCard1BlockProps
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
}

export const FeatureCard1Block = forwardRef<
  HTMLDivElement,
  FeatureCard1BlockProps
>(({ content, className, ...rest }, ref) => (
  <div
    ref={ref}
    className={classNames(
      "wb-bg-primary wb-border-primary wb-flex wb-flex-col wb-gap-4 wb-rounded-[1.25rem] wb-border wb-p-[1.88rem]",
      className,
    )}
    {...rest}
  >
    {content}
  </div>
));

FeatureCard1Block.displayName = "FeatureCard1Block";
